<template>
  <section id="test-results-entity-form">
    <div class="container-sm" v-loading="loading">
      <div class="testResultsTable-block">
        <div class="testResultsTable-header-block">
          <div class="left-header-block">
            <h3>TEST RESULTS</h3>
          </div>
          <div class="right-header-block">
            <div class="medications-table">
              <el-button @click="medicationDialogVisible = true">
                <img src="@/assets/images/icons/medication-btn.svg" alt="icon" />
                <span>MEDICATIONS</span>
              </el-button>
            </div>
            <div class="accession-number">
              <span class="pr-10">Accession ID :</span>
              <span class="value">{{
                getSampleNameTestResultData &&
                  getSampleNameTestResultData.sample_name
                  ? getSampleNameTestResultData.sample_name
                  : "--"
              }}</span>
            </div>
            <div class="patient-name-block">
              <div class="patient-name">
                <span class="pr-10">Patient Name :</span>
                <span class="value">
                  {{
                    getSampleNameTestResultData &&
                      getSampleNameTestResultData.patient_demographics
                      ? getSampleNameTestResultData.patient_demographics
                        .givenName || "--"
                      : "--"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="subheader">
          <el-button class="sync-button" @click="syncWithTestsInfo()">
            SYNC WITH TEST INFO
          </el-button>
        </div>
        <div class="testResultsTable-body-block">
          <div class="all-cases-view">
            <div class="primary-content-view-new">
              <div class="listings listings__table listings__all-cases" id="all-cases-listings">
                <el-form ref="form" :model="toxicologyData">
                  <div class="screening-block">
                    <div class="primary-data-entry" v-if="hasScreeingValidity">
                      <h3 class="primary-header">Screen Validity</h3>

                      <el-table :data="screenValidity" style="width: 100%">
                        <el-table-column prop="Full Name" label="Drug" min-width="250">
                          <template #default="scope">
                            <div class="dark-blue-color">
                              {{
                                scope.row.report_test_name ||
                                scope.row["Full name"]
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="result" label="Result" min-width="180">
                          <template #default="scope">
                            <div class="pr-20">
                              <el-input v-model="scope.row.result" placeholder="Enter Result" @input="
                                checkScreeningValidityTestValues(scope.row)
                                "></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="resultValue" label="Results Value" min-width="180">
                          <template #default="scope">
                            <div class="pr-20">
                              <el-input v-model="scope.row.result_value" placeholder="Enter Result Value"
                                readonly></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="cutOff" label="Cut Off" width="200">
                          <template #default="scope">
                            <span v-if="scope.row.cutoff">{{
                              scope.row.cutoff +
                              " " +
                              (scope.row.report_test_name != "pH" ||
                                scope.row.report_test_name != "URINE CREATININE"
                                ? "ng/mL"
                                : "")
                            }}</span>
                            <span v-else>--</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                    <div class="primary-data-entry pb-1rem" v-if="hasScreeingTests">
                      <h3 class="primary-header">Screen Results</h3>

                      <el-table :data="screenResults" style="width: 100%">
                        <el-table-column prop="Full Name" label="Drug" min-width="250">
                          <template #default="scope">
                            <div class="dark-blue-color">
                              {{
                                scope.row.report_test_name ||
                                scope.row["Full name"]
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="result" label="Result" min-width="180">
                          <template #default="scope">
                            <div class="pr-20">
                              <el-input v-model="scope.row.result" placeholder="Enter Result"
                                @input="checkScreeningTestValues(scope.row)"></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="resultValue" label="Results Value" min-width="180">
                          <template #default="scope">
                            <div class="pr-20">
                              <el-input v-model="scope.row.result_value" placeholder="Enter Result Value"
                                readonly></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="cutOff" label="Cut Off" width="200">
                          <template #default="scope">
                            <span v-if="(scope.row.high_limit || scope.row.low_limit) &&
                              (scope.row.report_test_name === 'pH' ||
                                scope.row.report_test_name === 'OXIDANTS')
                            ">{{
                              parseFloat(scope.row.low_limit) + "-" + parseFloat(scope.row.high_limit)
                              }}</span>
                            <span v-else-if="scope.row.cutoff">{{
                              scope.row.cutoff +
                              " " +
                              (scope.row.report_test_name != "URINE CREATININE"
                                ? scope.row.Units
                                : "")
                            }}</span>
                            <span v-else>--</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div class="conformation-block pb-1rem" v-if="hasConfirmationTests">
                    <h2 v-if="hasConfirmationTests">
                      <span>
                        <img src="@/assets/images/icons/confirmation-tests.svg" alt="icon" />
                      </span>
                      CONFIRMATION TESTS
                    </h2>

                    <div class="primary-data-entry" v-for="(test, index) of categoryCodes" :key="index">
                      <div class="each-table">
                        <h3 class="primary-header">{{ test.name }}</h3>
                        <el-table :data="test.results" style="width: 100%">
                          <el-table-column prop="report_test_name" label="Test Screen" min-width="250" fixed="left">
                          </el-table-column>
                          <el-table-column prop="testOutcome" label="Test Outcome" min-width="240">
                            <template #default="scope">
                              <div class="date-type-checkbox">
                                <el-radio-group v-model="scope.row.flag">
                                  <el-radio label="Positive" value="detected"></el-radio>
                                  <el-radio label="Not Detected"></el-radio>
                                </el-radio-group>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="result" label="Measured Results" min-width="150">
                            <template #default="scope">
                              <el-input type="text" v-model="scope.row.result"
                                @input="checkConfirmationTestValues(scope.row)"></el-input>
                              <p v-if="scope.row.invalid_range">
                                {{ scope.row.invalid_range }}
                              </p>
                            </template>
                          </el-table-column>

                          <el-table-column prop="determination" label="Determination" width="300">
                            <template #default="scope">
                              <div class="date-type-checkbox">
                                <el-radio-group v-model="scope.row.interpretation">
                                  <el-radio label="INCONSISTENT"></el-radio>
                                  <el-radio label="CONSISTENT"></el-radio>
                                </el-radio-group>
                              </div>
                            </template>
                          </el-table-column>

                          <el-table-column prop="cutoff" align="center" label="Cut Off" width="100">
                            <template #default="scope">
                              <span v-if="scope.row.cutoff">{{
                                scope.row.cutoff + " " + scope.row.Unit
                              }}</span>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>

                          <el-table-column align="center" label="Range" width="150">
                            <template #default="scope">
                              <span>{{
                                scope.row.LLMI +
                                "-" +
                                scope.row.ULMI +
                                " " +
                                scope.row.Unit
                              }}</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                  <div class="conformation-block pb-1rem" v-if="hasetgetsTests">
                    <h2 class="mt-20" v-if="hasetgetsTests">
                      <span>
                        <img src="@/assets/images/icons/confirmation-tests.svg" alt="icon" />
                      </span>
                      ETG_ETS TESTS
                    </h2>
                    <div class="primary-data-entry" v-for="(test, index) of etgetsCodes" :key="index">
                      <div class="each-table">
                        <h3 class="primary-header">{{ test.name }}</h3>
                        <el-table :data="test.results" style="width: 100%">
                          <el-table-column prop="report_test_name" label="Test Screen" min-width="250" fixed="left">
                          </el-table-column>
                          <el-table-column prop="testOutcome" label="Test Outcome" min-width="240">
                            <template #default="scope">
                              <div class="date-type-checkbox">
                                <el-radio-group v-model="scope.row.flag">
                                  <el-radio label="Positive" value="detected"></el-radio>
                                  <el-radio label="Not Detected"></el-radio>
                                </el-radio-group>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="result" label="Measured Results" min-width="150">
                            <template #default="scope">
                              <el-input type="text" v-model="scope.row.result"
                                @input="checkETGETSTestValues(scope.row)"></el-input>
                              <p v-if="scope.row.invalid_range">
                                {{ scope.row.invalid_range }}
                              </p>
                            </template>
                          </el-table-column>

                          <el-table-column prop="determination" label="Determination" width="300">
                            <template #default="scope">
                              <div class="date-type-checkbox">
                                <el-radio-group v-model="scope.row.interpretation">
                                  <el-radio label="INCONSISTENT"></el-radio>
                                  <el-radio label="CONSISTENT"></el-radio>
                                </el-radio-group>
                              </div>
                            </template>
                          </el-table-column>

                          <el-table-column prop="cutoff" align="center" label="Cut Off" width="100">
                            <template #default="scope">
                              <span v-if="scope.row.cutoff">{{
                                scope.row.cutoff + " " + scope.row.Unit
                              }}</span>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>

                          <el-table-column align="center" label="Range" width="150">
                            <template #default="scope">
                              <span>{{
                                scope.row.LLMI +
                                "-" +
                                scope.row.ULMI +
                                " " +
                                scope.row.Unit
                              }}</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
          <div class="action-buttons-empty-space"></div>
          <div class="action-buttons fixed">
            <el-button class="btn radius-button radius-button-red" @click="backToReport">
              Back To Report
            </el-button>
            <el-button class="btn radius-button" @click="askReason">Update &amp; Preview
            </el-button>
          </div>
        </div>
      </div>
      <div class="medication-popup-block">
        <div class="default-modal">
          <div v-if="medicationDialogVisible">
            <el-dialog top="10%" width="40%" v-model="medicationDialogVisible">
              <div class="dialog-header">
                <span class="header-part"> MEDICATION DETAILS </span>
                <el-button size="medium" class="el-white" type="info" plain @click="medicationDialogVisible = false">
                  <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
              </div>
              <div class="popup-date">
                <ul class="medication-list" v-if="prescribedMedications && prescribedMedications.length">
                  <li class="list-items" v-for="medication in prescribedMedications" :key="medication">
                    <span class="prescribed-medications">
                      <img src="@/assets/images/icons/success-medication-blue.svg" alt="icon" />
                      <span>
                        {{ medication }}
                      </span>
                    </span>
                  </li>
                </ul>
                <h3 v-else>No Medications</h3>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
      <div class="medication-popup-block">
        <div class="default-modal">
          <div v-if="showMessagePopup">
            <el-dialog top="10%" width="40%" v-model="showMessagePopup">
              <div class="dialog-header">
                <span class="header-part"> Alert </span>
                <el-button size="medium" class="el-white" type="info" plain @click="showMessagePopup = false">
                  <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
              </div>
              <div class="popup-date">
                <ul class="medication-list">
                  <li class="list-items">
                    <span>
                      <span>
                        No test information changed for the given accession
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <ResonForChange v-if="takeReasonDialog" v-on:close="takeReasonDialog = false" v-on:reasonSubmit="updateResults"
      title="Reason for Update"></ResonForChange>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import ResonForChange from "@/components/misc/ResonForChange";

export default {
  data() {
    return {
      toxicologyData: {
        result: "",
        resultValue: "",
        testOutcome: "",
        measuredResults: "",
        creativeNormalized: "",
        determination: "",
      },
      loading: false,
      medicationDialogVisible: false,
      caseId: null,
      reportData: null,
      categoryCodes: [],
      etgetsCodes: [],
      screenResults: [],
      screenValidity: [],
      hasScreeingTests: false,
      hasConfirmationTests: false,
      hasetgetsTests: false,
      hasScreeingValidity: false,
      medications: "",
      prescribedMedications: [],
      takeReasonDialog: false,
      showMessagePopup: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  components: {
    ResonForChange,
  },
  mixins: [AppHelper],
  components: {
    ResonForChange,
  },

  computed: {
    ...mapGetters("respiratoryFileUpload", [
      "getSampleNameTestResultData",
      "getUpdateToxicologyTestReportStatus",
    ]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("cases", ["getToxicologyTests"]),

    resultFileId() {
      return this.$route.params.result_file_id;
    },

    sampleNameId() {
      return this.$route.params.report_id;
    },
    testResultsId() {
      return this.$route.params.test_results_id;
    },
  },
  methods: {
    async syncWithTestsInfo() {
      try {
        this.loading = true;
        let params = {
          test_result_id: this.testResultsId,
        };
        await this.$store.dispatch("cases/fetchToxicologyTests", params);
        if (
          this.getToxicologyTests &&
          this.getSampleNameTestResultData &&
          this.getSampleNameTestResultData.result_summary
        ) {
          let newScreeningResultsEqual =
            this.getToxicologyTests.screening_results;
          let oldScreeningResultsEqual =
            this.getSampleNameTestResultData.result_summary.screen_results;
          let newConfirmationResultsEqual =
            this.getToxicologyTests.confirmation_results;
          let oldConfirmationResultsEqual =
            this.getSampleNameTestResultData.result_summary
              .confirmation_results;
          let newETGETSResultsEqual = this.getToxicologyTests.etg_ets_results;
          let oldETGETSResultsEqual =
            this.getSampleNameTestResultData.result_summary.etg_ets_results;
          if (
            newScreeningResultsEqual.length ===
            oldScreeningResultsEqual.length &&
            newConfirmationResultsEqual.length ===
            oldConfirmationResultsEqual.length &&
            newETGETSResultsEqual.length === oldETGETSResultsEqual.length
          ) {
            this.showMessagePopup = true;
          } else {
            if (this.getToxicologyTests && this.showMessagePopup == false) {
              this.reportData = this.getToxicologyTests;
              this.prescribedMedications =
                this.reportData &&
                  this.reportData.medication &&
                  this.reportData.medication.length
                  ? this.reportData.medication
                  : [];
              this.screenResults = this.reportData.screening_results || [];
              this.confirmationResults =
                this.reportData.confirmation_results || [];
              this.confirmationResults = this.confirmationResults.sort(
                function (a, b) {
                  return (
                    ("" + a.category_code)?.localeCompare(b.category_code) || 0
                  );
                }
              );

              this.hasConfirmationTests = this.confirmationResults.length
                ? true
                : false;

              this.etgetsResults = this.reportData.etg_ets_results || [];
              this.etgetsResults = this.etgetsResults.sort(function (a, b) {
                return (
                  ("" + a.category_code)?.localeCompare(b.category_code) || 0
                );
              });

              this.hasetgetsTests =
                this.etgetsResults.length
                  ? true
                  : false;
              this.hasScreeingTests = this.screenResults.length ? true : false;

              this.screenResults = this.screenResults.sort(function (a, b) {
                return (
                  ("" + a.report_test_name)?.localeCompare(
                    b.report_test_name
                  ) || 0
                );
              });

              this.categoryCodes = this.confirmationResults.map(
                (result) => result.category
              );

              // removed duplicates
              this.categoryCodes = [...new Set(this.categoryCodes)];

              this.categoryCodes = this.categoryCodes.map((categoryCode) => {
                return {
                  name: categoryCode,
                  results: this.getCategoryCodeData(
                    categoryCode,
                    this.confirmationResults
                  ),
                };
              });
              this.etgetsCodes = this.etgetsResults.map(
                (result) => result.category
              );

              // removed duplicates
              this.etgetsCodes = [...new Set(this.etgetsCodes)];

              this.etgetsCodes = this.etgetsCodes.map((categoryCode) => {
                return {
                  name: categoryCode,
                  results: this.getCategoryCodeData(
                    categoryCode,
                    this.etgetsResults
                  ),
                };
              });
              if (this.showMessagePopup == false) {
                successNotification("Results Synced Successfully");
              }
            }
          }
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.caseId = this.$route.params.case_id;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchSampleNameTestResultsData",
          {
            result_file_id: this.resultFileId,
            sample_name_id: this.sampleNameId,
            test_results_id: this.testResultsId,
          }
        );

        if (this.getSampleNameTestResultData) {
          this.reportData = this.getSampleNameTestResultData;

          this.medications =
            this.reportData &&
              this.reportData.result_summary &&
              this.reportData.result_summary.prescribed_medications &&
              this.reportData.result_summary.prescribed_medications.length
              ? this.reportData.result_summary.prescribed_medications.join(
                ",  "
              )
              : "- No Medications -";
          this.prescribedMedications =
            this.reportData &&
              this.reportData.result_summary &&
              this.reportData.result_summary.prescribed_medications &&
              this.reportData.result_summary.prescribed_medications.length
              ? this.reportData.result_summary.prescribed_medications
              : [];

          this.screenResults =
            this.reportData.result_summary.screen_results || [];
          this.screenValidity =
            this.reportData.result_summary.screen_validity || [];

          this.confirmationResults =
            this.reportData.result_summary.confirmation_results || [];

          this.confirmationResults = this.confirmationResults.sort(function (
            a,
            b
          ) {
            return ("" + a.category_code)?.localeCompare(b.category_code) || 0;
          });

          this.hasConfirmationTests = this.confirmationResults.length
            ? true
            : false;

          this.etgetsResults =
            this.reportData.result_summary.etg_ets_results || [];

          this.etgetsResults = this.etgetsResults.sort(function (a, b) {
            return ("" + a.category_code)?.localeCompare(b.category_code) || 0;
          });

          this.hasetgetsTests =
            this.etgetsResults.length
              ? true
              : false;
          this.hasScreeingTests = this.screenResults.length ? true : false;

          this.screenResults = this.screenResults.sort(function (a, b) {
            return (
              ("" + a.report_test_name)?.localeCompare(b.report_test_name) || 0
            );
          });

          this.hasScreeingValidity = this.screenValidity.length ? true : false;

          this.screenValidity = this.screenValidity.sort(function (a, b) {
            return (
              ("" + a.report_test_name)?.localeCompare(b.report_test_name) || 0
            );
          });

          this.categoryCodes = this.confirmationResults.map(
            (result) => result.category
          );

          // removed duplicates
          this.categoryCodes = [...new Set(this.categoryCodes)];

          this.categoryCodes = this.categoryCodes.map((categoryCode) => {
            return {
              name: categoryCode,
              results: this.getCategoryCodeData(
                categoryCode,
                this.confirmationResults
              ),
            };
          });
          this.etgetsCodes = this.etgetsResults.map(
            (result) => result.category
          );

          // removed duplicates
          this.etgetsCodes = [...new Set(this.etgetsCodes)];

          this.etgetsCodes = this.etgetsCodes.map((categoryCode) => {
            return {
              name: categoryCode,
              results: this.getCategoryCodeData(
                categoryCode,
                this.etgetsResults
              ),
            };
          });
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    getCategoryCodeData(category, data) {
      return data
        .filter((result) => result.category === category)
        .sort(
          (a, b) => a.report_test_name?.localeCompare(b.report_test_name) || 0
        );
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async updateResults(reason) {
      try {
        this.loading = true;
        let params = this.prepareParams();
        params.data.update_reason = reason;
        await this.$store.dispatch(
          "respiratoryFileUpload/updateToxicologyTestReports",
          params
        );
        if (this.getUpdateToxicologyTestReportStatus) {
          successNotification("Test report details updated successfully");

          setTimeout(() => {
            this.previewReport();
            this.backToReport();
          }, 1000);
        } else {
          errorNotification("Error in updating Test report details");
        }
        this.takeReasonDialog = false;
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        //
      }
    },

    async previewReport() {
      let report = this.reportData;
      let routerData = this.$router.resolve({
        name: "ResultFileReport",
        params: {
          result_file_id: this.resultFileId,
          report_id: this.sampleNameId,
          test_results_id: this.testResultsId,
        },
      });
      window.open(routerData.href, "_blank");
    },
    prepareParams() {
      let confirmation_results = this.prepareConfirmationResults();
      let etgets_results = this.prepareETGETSResult();
      return {
        result_file_id: this.resultFileId,
        sample_name_id: this.sampleNameId,
        test_result_id: this.testResultsId,
        data: {
          confirmation_results: confirmation_results,
          etg_ets_results: etgets_results,
          screen_results: this.screenResults,
          screen_validity: this.screenValidity,
          screen_result_id: this.getSampleNameTestResultData.screen_result_id,
        },
      }
    },
    prepareConfirmationResults() {
      let data = [];
      this.categoryCodes.map((category) => {
        data = [...data, ...category.results];
      });
      return data;
    },
    prepareETGETSResult() {
      let data = [];
      this.etgetsCodes.map((category) => {
        data = [...data, ...category.results];
      });
      return data;
    },

    checkScreeningTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        const testName = (test.test_name || test.report_test_name || "").trim().toUpperCase();
        if (["PH", "URINE CREATININE", "OXIDANTS"].includes(testName)) {
          if (value < test.low_limit || value > test.high_limit) {
            test.result_value = "Abnormal";
          } else {
            test.result_value = "Normal";
          }
        } else if (value > test.cutoff) {
          test.result_value = "Positive";
        } else {
          test.result_value = "Negative";
        }
      }
    },

    checkScreeningValidityTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        if (value < test.low_limit || value > test.high_limit) {
          test.result_value = "Abnormal";
        } else {
          test.result_value = "Normal";
        }
      } else {
        test.result_value = "Normal";
      }
    },
    checkConfirmationTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        if (value > test.cutoff) {
          test.flag = "Positive";
          if (value > test.ULMI) {
            test.invalid_range = ">" + test.ULMI;
          } else {
            test.invalid_range = "";
          }
        } else {
          test.flag = "Not Detected";
          if (value < test.LLMI) {
            test.invalid_range = "<" + test.LLMI;
          } else {
            test.invalid_range = "";
          }
        }
      } else {
        test.invalid_range = "";
        test.flag = "Not Detected";
      }

      this.updateInterpretationForSelectedTest(test);
    },
    checkETGETSTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        if (value > test.cutoff) {
          test.flag = "Positive";
          if (value > test.ULMI) {
            test.invalid_range = ">" + test.ULMI;
          } else {
            test.invalid_range = "";
          }
        } else {
          test.flag = "Not Detected";
          if (value < test.LLMI) {
            test.invalid_range = "<" + test.LLMI;
          } else {
            test.invalid_range = "";
          }
        }
      } else {
        test.invalid_range = "";
        test.flag = "Not Detected";
      }

      this.updateInterpretationForSelectedTest(test);
    },

    updateInterpretationForSelectedTest(selectedTest) {
      let CONSISTENT, confirmation, comment;
      let flag = selectedTest.flag;
      let grouped = [];
      let testMedications = selectedTest.mapped_medications || [];
      testMedications.push(selectedTest.medication);
      if (selectedTest.test_name) {
        testMedications.push(selectedTest.test_name);
      }
      let found = false;
      if (testMedications && testMedications.length) {
        testMedications = testMedications.map((e) => e.toUpperCase());
        grouped = this.arrayInterSection(
          testMedications,
          this.prescribedMedications
        );
        found = grouped.length > 0;
      }

      if (found) {
        if (flag == "Not Detected") {
          CONSISTENT = "INCONSISTENT";
        } else if (flag === "Not Tested") {
          CONSISTENT = "NOT TESTED";
        } else {
          CONSISTENT = "CONSISTENT";
        }

        comment = "Prescribed";
        confirmation = true;
      } else {
        if (flag == "Positive") {
          CONSISTENT = "INCONSISTENT";
          confirmation = true;
          comment = "Not Prescribed";
        } else if (flag === "Not Tested") {
          CONSISTENT = "NOT TESTED";
        } else {
          CONSISTENT = "CONSISTENT";
        }
      }
      if (selectedTest.not_tested) {
        delete selectedTest["not_tested"];
      }
      selectedTest.interpretation = CONSISTENT;
      selectedTest.confirmation = confirmation;
      selectedTest.comment = comment;
    },

    backToReport() {
      if (
        this.$route.query.origin == "test_reports" &&
        this.$route.query.case_id
      ) {
        this.$router.push({
          name: "CaseView",
          params: { case_id: this.$route.query.case_id },
          // Spread the full query so all list-view params (filters, pagination,
          // sort order, and the originating tab via redirectRoute) survive the
          // trip back and are available when marking for physician.
          query: {
            ...this.$route.query,
          },
        });
      } else {
        this.$router.push({
          name: "viewprogress",
          params: {
            result_file_id: this.resultFileId,
          },
        });
      }
    },
  }
};
</script>

<style lang="scss">
@mixin flex-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#test-results-entity-form {
  .testResultsTable-block {
    .testResultsTable-header-block {
      @include flex-items;
      padding: 5px 10px;
      margin: 1rem 0;
      color: #363636;
      font-size: 15px;
      border: 1.2px solid #e7e7f7;
      border-radius: 5px;

      .left-header-block {
        @include flex-items;

        h3 {
          font-size: 15px;
        }
      }

      .right-header-block {
        @include flex-items;

        .medications-table {
          .el-button {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 25px;
            min-height: auto;
            padding: 0 10px;
            color: white;
            font-size: 14px;
            font-weight: 500;
            text-transform: uppercase;
            background-color: #eb5757;
            border: none;
            border-radius: 5px;

            img {
              position: relative;
              top: 2.5px;
              right: 3px;
            }
          }
        }

        .accession-number {
          padding: 0 5px;
          margin: 0 5px;
          border-right: 1px solid #e7e7f7;
          border-left: 1px solid #e7e7f7;

          .value {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 25px;
            min-height: auto;
            padding: 0 10px;
            color: white;
            font-size: 12.5px;
            font-weight: 500;
            text-transform: uppercase;
            background: #3285ec;
            border-radius: 5px;
          }
        }

        .patient-name-block {
          .patient-name {
            .value {
              color: #000;
              font-weight: 600;
            }
          }
        }
      }
    }

    .subheader {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .sync-button {
        min-height: 34px;
        padding: 0 15px;
        color: #fff;
        font-weight: 500;
        line-height: 0.5px;
        background: #273480;
        border: none;
        border-radius: 7px;

        &:hover,
        &:focus {
          background: #273480;
          color: #fff;
        }
      }
    }

    .testResultsTable-body-block {
      color: #363636;

      h2 {
        padding: 1rem 5px 0;
        font-size: 20px;
      }

      .primary-header {
        padding: 1.5rem 5px 0.5rem;
        // text-transform: uppercase;
        font-size: 16px;
      }

      .el-input__inner,
      .el-radio {
        height: 30px;
      }

      .date-type-checkbox {
        .el-radio__input .el-radio__inner {
          box-shadow: 0 0 0 1px #ced1d6;
          border-color: transparent;
        }

        .el-radio__input.is-checked .el-radio__inner {
          background-color: #0a5da6;
          border-color: #fff;
        }

        .el-radio__input.is-checked+.el-radio__label {
          color: #0a5da6;
        }
      }

      .listings__table .el-table table {
        border-spacing: 0 2px;
      }

      .action-buttons-empty-space {
        height: 55px;
      }

      .action-buttons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 2.2rem;
        background-color: #fff;

        &.fixed {
          position: fixed;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 99;
        }

        .btn {
          &.radius-button {
            background-color: #273480;

            &.radius-button-red {
              color: #273480;
              background: #fff;
              border: 1px solid #dedbdb;
              border-radius: 6px;

              &:hover,
              &:active,
              &:focus {
                box-shadow: 0 0 0 1px #dedbdb;
              }
            }
          }
        }
      }
    }
  }

  .medication-popup-block {
    .medication-list {
      display: grid;

      grid-template-columns: auto auto auto;
      row-gap: 10px;

      .list-items {
        .prescribed-medications {
          overflow: hidden;
          padding: 3px 7px;
          color: #014f49;
          font-weight: 500;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: rgba(231, 231, 247, 0.6);
          border-radius: 15px;

          img {
            position: relative;
            top: 2px;
            right: 3px;
          }
        }
      }
    }

    h3 {
      color: #eb5757;
      text-align: center;
    }
  }
}
</style>
